module.exports = __webpack_public_path__ + "static/media/text-image.62279f2d.webp";